/** PermissionRoute — blocks a route tree behind a jerry.* permission point.
 *
 * The backend endpoint guard is the real enforcement (US-H01 BR1); this
 * wrapper is the experience layer — render a clear 403 instead of letting
 * unauthorized users into a page whose every request would fail. */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Empty, Spin } from "antd";
import { usePermissions } from "../../hooks";

export default function PermissionRoute({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
}) {
  const { hasPermission, isLoading } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "50vh" }} data-testid="permission-route-loading">
        <Spin />
      </div>
    );
  }

  if (!hasPermission(permission)) {
    return (
      <div
        style={{ display: "grid", placeItems: "center", minHeight: "50vh" }}
        data-testid="permission-route-denied"
      >
        <Empty
          description={`无权访问（需要权限：${permission}）。当前页面：${location.pathname}`}
        />
      </div>
    );
  }

  return <>{children}</>;
}
